/**
 * 项目工单月报导出实体
 */

import { useState, useEffect } from 'react';
import {
    Row,
    Col,
    message,
    Modal,
    Table,
    ConfigProvider,
    Image as AntdImage,
    Button,
    Progress,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    locale,
    defaultImage,
    AliyunOSSclient
} from '../../incs/FunHelper.js';
import { saveAs } from 'file-saver';
// import docxtemplater from 'docxtemplater';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import JSZipUtils from 'jszip-utils';
import ImageModule from 'docxtemplater-image-module-free' //这句是导出图片用的
import CNF from '../../incs/Config.js';

// 工单报表
import WOWTCD from '../reports/WOWTCD.js';
import WOWDCL from '../reports/WOWDCL.js';
import WOWDCT from '../reports/WOWDCT.js';
import WOWDCP from '../reports/WOWDCP.js';

import ZHCLOGO from '../../images/yd_logo.jpg';
import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

const ZHCCOMPANY = '中国移动通信集团湖南有限公司怀化分公司';
const XZTCOMPANY = '湖南新致腾信息科技有限公司';

var date = new Date();
var YEAR = date.getFullYear();
var MONTH = date.getMonth();
if (MONTH < 1) {
    MONTH = 1;
}
var INIDATE = new Date(YEAR, MONTH, 0);
const DAYS = INIDATE.getDate();

const thStyle = {
    marginTop: 20
}

const MREntity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [projectULID, setProjectULID] = useState('');

    // 报表数据
    const [woDayData, setWODayData] = useState([]); //  工单日数据
    const [woLevelData, setWOLevelData] = useState([]);
    const [woTypeData, setWOTypeData] = useState([]);
    const [woProductData, setWOProductData] = useState([]);

    // 工单数据
    const [woData, setWOData] = useState([]);
    const [woCount, setWOCount] = useState(0);
    const [dayMaxCount, setDayMaxCount] = useState(0);
    const [dayMaxDate, setDayMaxDate] = useState('');
    const [dayAverageCount, setDayAverageCount] = useState(0);
    const [productMaxNumber, setProductMaxNumber] = useState('');   // 工单数量最多的产品编码
    const [productMaxCount, setProductMaxCount] = useState(0);      // 工单数量最多的工单数量
    const [avgWOSecondsText, setAvgWOSecondsText] = useState('');   // 工单平均完成时长
    const [longestWONumber, setLongestWONumber] = useState('');     // 耗时最长的工单编号
    const [longestWODescription, setLongestWODescription] = useState('');   // 耗时最长的工单描述
    const [longestWOStartTime, setLongestWOStartTime] = useState('');   // 耗时最长的工单开始时间
    const [longestWOEndTime, setLongestWOEndTime] = useState('');   // 耗时最长的工单结束时间
    const [longestWOSecondsText, setLongestWOSecondsText] = useState(''); // 工单最长耗时字符串

    // 工单图片
    const [woImageList, setWOImageList] = useState([]);


    useEffect(() => {
        // 显示报表
        setOpen(true);

        /***
         * 获取月份的天数
         */
        const getMonthDay = () => {
            let yearMonth = props.month.split('-');
            let date = new Date(yearMonth[0], yearMonth[1], 0);
            return date.getDate();
        }

        /**
         * 日工单处理走势
         * @param {Ulid} projectUlid 
         */
        const woDay = (projectUlid) => {
            const params = {
                'project_ulid': projectUlid,
                'start_date': props.month + '-01',
                'end_date': props.month + '-' + getMonthDay()
            }
            $.ajax({
                url: `${CNF.api}reports/wo/wtcd${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        let cnt = 0;
                        let dayMaxCount = 0;
                        let dayMaxDate = '';
                        for (let i = 0; i < data.dat.length; i++) {
                            cnt += data.dat[i].count
                            if (data.dat[i].count > dayMaxCount) {
                                dayMaxCount = data.dat[i].count;
                                dayMaxDate = data.dat[i].date
                            }
                        }
                        setWODayData(data.dat);
                        setWOCount(cnt);
                        setDayMaxCount(dayMaxCount);
                        setDayMaxDate(dayMaxDate);
                        setDayAverageCount((cnt / DAYS).toFixed(CNF.DPL));
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }

        /**
         * 按工单类型分
         * @param {*} projectUlid 
         */
        const woType = (projectUlid) => {
            const params = {
                'project_ulid': projectUlid,
                'start_date': props.month + '-01',
                'end_date': props.month + '-' + getMonthDay()
            }
            $.ajax({
                url: `${CNF.api}reports/wo/wdct${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setWOTypeData(data.dat.map((item) => ({
                                ...item,
                                type_name: item.type,
                            })))
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }

        /**
         * 按工单等级分
         * @param {Ulid} projectUlid
         */
        const woLevel = (projectUlid) => {
            const params = {
                'project_ulid': projectUlid,
                'start_date': props.month + '-01',
                'end_date': props.month + '-' + getMonthDay()
            }
            $.ajax({
                url: `${CNF.api}reports/wo/wdcl${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            let d = [];
                            for (let i = 0; i < data.dat.length; i++) {
                                let item = data.dat[i]
                                for (let i of CNF.woLevels) {
                                    if (parseInt(item['level']) === parseInt(i.value)) {
                                        item['level_name'] = i.key
                                    }
                                }
                                d.push(item);
                            }
                            setWOLevelData(d);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }

        /**
         * 按工单产品分
         * @param {Ulid} projectUlid 
         */
        const woProduct = (projectUlid) => {
            const params = {
                'project_ulid': projectUlid,
                'start_date': props.month + '-01',
                'end_date': props.month + '-' + getMonthDay()
            }
            $.ajax({
                url: `${CNF.api}reports/wo/wdcp${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        let woProductData = data.dat;
                        let productMaxNumber = '';
                        let productMaxCount = 0;
                        let productNumbers = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            productNumbers.push(data.dat[i].type);
                            if (data.dat[i].count > productMaxCount) {
                                productMaxNumber = data.dat[i].type;
                                productMaxCount = data.dat[i].count;
                            }
                        }
                        setWOProductData(woProductData);
                        setProductMaxNumber(productMaxNumber);
                        setProductMaxCount(productMaxCount);
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }

        /**
         * 获取工单明细
         * @param {Ulid} projectUlid 
         */
        const woObtain = (projectUlid) => {
            const params = {
                'project_ulid': projectUlid,
                'start_date': props.month + '-01',
                'end_date': props.month + '-' + getMonthDay(),
                'page_size': 65535,
                'current_index': 1
            }
            $.ajax({
                url: `${CNF.api}wos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            // 获取总秒数
                            let totalSeconds = 0;
                            // 耗时最长工单
                            let longestWONumber = '';
                            let longestWOStartTime = '';
                            let longestWOEndTime = '';
                            let longestWODescription = '';
                            let longestWOSeconds = 0;
                            for (let i = 0; i < data.dat.length; i++) {
                                // 获取工单等级名称
                                for (let item of CNF.woLevels) {
                                    if (parseInt(data.dat[i].level) === parseInt(item.value)) {
                                        data.dat[i]['level_name'] = item.key;
                                        break;
                                    }
                                }
                                // 获取工单类型名称
                                data.dat[i]['type_name'] = data.dat[i]['type'];

                                let startTime = data.dat[i].start_time
                                let endTime = data.dat[i].end_time
                                let ts = new Date(startTime).getTime();
                                let te = new Date(endTime).getTime();
                                // 计算时间差（秒）
                                let tc = (te - ts) / 1000;
                                totalSeconds += tc;

                                // 获取耗时最长工单信息
                                if (tc > longestWOSeconds) {
                                    longestWOSeconds = tc;
                                    longestWONumber = data.dat[i].number;
                                    longestWOStartTime = startTime;
                                    longestWOEndTime = endTime;
                                    longestWODescription = data.dat[i].description;
                                }
                            }
                            // 计算平均每个工单耗时（秒）
                            let avgWOSeconds = Math.floor(totalSeconds / data.dat.length);
                            // 组装工单平均耗时字符串
                            let avgWOSecondsText = secondsToTimeText(avgWOSeconds);
                            // 组装工单最长耗时字符串
                            let longestWOSecondsText = secondsToTimeText(longestWOSeconds);

                            // 更新数据
                            setWOData(data.dat);
                            setAvgWOSecondsText(avgWOSecondsText);
                            setLongestWONumber(longestWONumber);
                            setLongestWODescription(longestWODescription);
                            setLongestWOStartTime(longestWOStartTime);
                            setLongestWOEndTime(longestWOEndTime);
                            setLongestWOSecondsText(longestWOSecondsText);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }

        /**
         * 获取工单图片列表
         */
        const woImageLists = (projectUlid) => {
            const params = {
                'project_ulid': projectUlid,
                'start_date': props.month + '-01',
                'end_date': props.month + '-' + getMonthDay(),
                'page_size': 65535,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}wo/images${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            let imageArr = data.dat;
                            let params = { 'acl': 'GetObject' }
                            $.ajax({
                                url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                                headers: AddRequestHeaders(),
                                type: 'GET', success: function (data) {
                                    if (data.res === 0) {
                                        const token = data.dat;
                                        // setOssToken(token);
                                        let retWOImageList = [];
                                        for (let i = 0; i < imageArr.length; i++) {
                                            let item = imageArr[i];
                                            try {
                                                // 去掉路径‘/’
                                                let result = AliyunOSSclient(token).signatureUrl(item.path, {
                                                    expires: 3600,
                                                    response: {
                                                        'content-disposition': 'attachment; filename="' + item.name + '"'
                                                    }
                                                });
                                                retWOImageList.push({
                                                    uid: i + 1,
                                                    ulid: item.key,
                                                    url: result,
                                                    preview: result,
                                                    status: 'done',
                                                    percent: 100,
                                                    size: item.size,
                                                    path: item.path,
                                                    description: item.description
                                                });
                                            } catch {
                                            }
                                        }
                                        setWOImageList(retWOImageList);
                                    } else {
                                        messageApi.error(data.msg, CNF.messageDuration);
                                    }
                                }
                            });
                        } else {
                        }
                    }
                }
            })
        }

        /**
         * 初始化项目报表
         * @param {Ulid} projectUlid 
         */
        const initReport = (projectUlid) => {
            woDay(projectUlid);
            woLevel(projectUlid);
            woType(projectUlid);
            woProduct(projectUlid);
            woObtain(projectUlid);
            woImageLists(projectUlid);
        }
        if (projectULID !== props.record.key) {
            setProjectULID(props.record.key);
            // 初始化报表
            initReport(props.record.key);
        }

    }, [props, messageApi, projectULID]);

    const cancel = () => {
        setLoading(false);
        setOpen(false);
    }


    /**
     * 组装耗时字符串
     * @param {秒} sec 
     * @returns 
     */
    const secondsToTimeText = (sec) => {
        // 计算天
        const DATESECONDS = 24 * 60 * 60;
        let days = 0;
        if (sec > DATESECONDS) {
            days = Math.floor(sec / DATESECONDS);
        }
        // 计算时
        let hours = 0;
        if (sec - days * DATESECONDS > 3600) {
            hours = Math.floor((sec - days * DATESECONDS) / 3600)
        }
        // 计算分
        let minutes = 0;
        if (sec - days * DATESECONDS - hours * 3600 > 60) {
            minutes = Math.floor((sec - days * DATESECONDS - hours * 3600) / 60)
        }
        // 计算秒
        let seconds = sec - days * DATESECONDS - hours * 3600 - minutes * 60;

        // 组装耗时字符串
        let secToTimeText = '';
        if (days > 0) {
            secToTimeText = days + ' 天 ' + hours + ' 小时 ' + minutes + ' 分 ' + seconds + ' 秒';
        } else if (hours > 0) {
            secToTimeText = hours + ' 小时 ' + minutes + ' 分 ' + seconds + ' 秒';
        } else if (minutes > 0) {
            secToTimeText = minutes + ' 分 ' + seconds + ' 秒';
        } else {
            secToTimeText = seconds + ' 秒';
        }
        return secToTimeText;
    }

    /**
     * base64转为ArrayBuffer
     * @param {*} dataUrl 
     * @returns 
     */
    const base64DataUrlToArrayBuffer = (dataUrl) => {
        const base64Regex = /^data:image\/(png|jpg|jpeg);base64,/;
        if (!base64Regex.test(dataUrl)) {
            return false;
        }
        const stringBase64 = dataUrl.replace(base64Regex, '');
        let binaryString;
        if (typeof window !== 'undefined') {
            binaryString = window.atob(stringBase64);
        } else {
            binaryString = new Buffer(stringBase64, 'base64').toString('binary');
        }
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            const ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes.buffer;
    }

    /**
     * 将报表转换为base64图片
     * @param {*} modal 
     * @param {*} imageCount 
     * @returns 
     */
    async function g2ToWordData(modal, imageCount) {
        let currentPromises = [];   //  当前正在执行的promise

        let g2ImageContainers = ['antv-g2-id-wowtcd', 'antv-g2-id-wowdcl', 'antv-g2-id-wowdct', 'antv-g2-id-wowdcp']
        // 工单图片转换成 base64 位图片
        let g2ImageBase64Urls = [];
        for (let i = 0; i < g2ImageContainers.length; i++) {
            let id = g2ImageContainers[i];
            let promise = new Promise(function (resolve, reject) {
                // 将目标文件对象保存为目标类型的文件，并命名。
                try {
                    // 工单报表转换成 base64 位图片
                    let imageBase64Urls = document.getElementById(id).querySelector('canvas')?.toDataURL();
                    resolve(imageBase64Urls);
                } catch {
                    reject();
                }
            }).then((base64) => {
                // 完成转换
                g2ImageBase64Urls.push(base64);
            })
            currentPromises.push(promise);
            // 更新下载进度
            // 根据图片的下载量来决定进度
            modal.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress percent={(parseFloat((i + 1) / imageCount * 100) - 0.01).toFixed(CNF.DPL)} />,
            }));
        };

        await Promise.race(currentPromises); // 等待任意一个promise完成
        let __currentPromises = [];
        for (let j = 0; j < currentPromises.length; j++) {
            let promise = currentPromises[j];
            promise.then(result => {
                if (!result) {
                    __currentPromises.push(promise);
                }
            });
        }
        currentPromises = __currentPromises;

        return g2ImageBase64Urls;
    }

    /**
     * 工单图片转换为可写入Word的Base64数据
     * @param {*} modal 
     * @param {*} images 
     * @param {*} imageCount   图片的总数量（含报表）
     * @param {*} currentCount 当前图片索引（报表数）
     * @returns 
     */
    async function woImageToWordData(modal, images, imageCount, currentCount) {
        let currentPromises = [];   //  当前正在执行的promise

        // 工单图片转换成 base64 位图片
        let woImageListBase64Urls = [];
        for (let i = 0; i < images.length; i++) {
            let url = images[i].url;
            let promise = fetch(url)
                .then(response => response.blob())
                .then(blob => new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result.split(',')[1]); // 分割数据URL的前缀
                    reader.onerror = error => reject(error);
                    reader.readAsDataURL(blob);
                }))
                .then((base64) => {
                    let item = {
                        'woImageDataUrl': `data:image/png;base64,${base64}`
                    }
                    woImageListBase64Urls.push(item);
                });
            currentPromises.push(promise);
            // 更新下载进度
            // 根据图片的下载量来决定进度
            modal.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress percent={(parseFloat((i + 1 + currentCount) / imageCount * 100) - 0.01).toFixed(CNF.DPL)} />,
            }));

            await Promise.race(currentPromises); // 等待任意一个promise完成
            let __currentPromises = [];
            for (let j = 0; j < currentPromises.length; j++) {
                let promise = currentPromises[j];
                promise.then(result => {
                    if (!result) {
                        __currentPromises.push(promise);
                    }
                });
            }
            currentPromises = __currentPromises;
        };

        return woImageListBase64Urls;
    }


    /**
     * 导出为 word
     */
    const exportAsWord = (modal, g2ImageBase64Urls, woImageListBase64Urls) => {
        // 初始化项目实体
        const record = props.record;
        // 设置模板变量的值，这个就是模板里所插入的内容数据，根据需要写成动态就好了。
        // 根据换行符拆分维护内容段落
        let mcArr = [];
        let mcs = props.record.maintenance_content.split('\n');
        for (let i = 0; i < mcs.length; i++) {
            let item = { 'content': mcs[i] };
            mcArr.push(item);
        }

        // 工单图片两张图片占word一行
        let woImageListDataUrls = [];
        for (let i = 0; i < woImageListBase64Urls.length; i += 2) {
            let item = {
                'woImageDataUrl1': woImageListBase64Urls[i].woImageDataUrl,
                'woImageDataUrl2': woImageListBase64Urls[i + 1]?.woImageDataUrl || '',
            }
            woImageListDataUrls.push(item);
        }

        let wordData = {
            projectName: props.record.name,
            date: props.month,
            maintenanceContents: mcArr,
            woCount: woCount,                                                        // 工单总数
            woCount1: woLevelData.length === 4 ? woLevelData[0].count : 0,           // 1级工单
            woCount2: woLevelData.length === 4 ? woLevelData[1].count : 0,           // 2级工单
            woCount3: woLevelData.length === 4 ? woLevelData[2].count : 0,           // 3级工单
            woCount4: woLevelData.length === 4 ? woLevelData[3].count : 0,           // 4级工单
            woHad: woTypeData.find((item) => item.type === CNF.woTypes[0].key)?.count || 0,                // 硬件工单
            woSof: woTypeData.find((item) => item.type === CNF.woTypes[1].key)?.count || 0,                // 软件工单
            woInt: woTypeData.find((item) => item.type === CNF.woTypes[2].key)?.count || 0,                // 网络工单
            woSer: woTypeData.find((item) => item.type === CNF.woTypes[3].key)?.count || 0,                // 需求工单
            woArt: woTypeData.find((item) => item.type === CNF.woTypes[4].key)?.count || 0,                // 其它工单
            woOth: woTypeData.find((item) => item.type === CNF.woTypes[5].key)?.count || 0,                // 人工工单
            dayMaxCount: dayMaxCount,
            dayMaxDate: dayMaxDate,
            dayAverageCount: dayAverageCount,
            productMaxNumber: productMaxNumber,
            productMaxCount: productMaxCount,
            woData: woData,
            woProductData: woProductData,
            woDayDataUrl: g2ImageBase64Urls[0],
            woLevelDataUrl: g2ImageBase64Urls[1],
            woTypeDataUrl: g2ImageBase64Urls[2],
            woProductDataUrl: g2ImageBase64Urls[3],
            avgWOSecondsText: avgWOSecondsText,
            longestWONumber: longestWONumber,
            longestWODescription: longestWODescription,
            longestWOStartTime: longestWOStartTime,
            longestWOEndTime: longestWOEndTime,
            longestWOSecondsText: longestWOSecondsText,
            woImageListDataUrls: woImageListDataUrls,         // 项目工单图片
        };

        /**
         * 读取并获得模板文件的二进制内容，是 docxtemplater 提供的固定写法。
         * MRT.docx是模板，React 写在 public 里，我们在导出的时候，会根据此模板来导出对应的数据。
         */
        const MRTPath = '/templates/' + props.preGroup.toLowerCase() + '/MRT.docx';
        // 读取模版文件为二进制内容
        JSZipUtils.getBinaryContent(MRTPath, function (error, content) {
            // 抛出异常
            if (error) {
                throw error;
            }
            // 导出图片
            var opts = {}
            opts.centered = false;       // 图片是否居中
            opts.fileType = 'docx';      // 文件类型（如docx、pptx等）
            opts.getImage = function (chartId) {
                return base64DataUrlToArrayBuffer(chartId);
            }
            // 设置图片大小
            opts.getSize = function (img, tagValue, tagName) {
                if (tagName === 'woImageDataUrl1' || tagName === 'woImageDataUrl2') {
                    return [321, 214];
                } else {
                    return [660, 440];
                }
            }

            // 创建图片模块
            var imageModule = new ImageModule(opts);

            // 创建一个 PizZip 实例，内容为模板的内容。
            let zip = new PizZip(content);
            // 创建并加载 docxtemplater 实例对象。

            /*****************旧方式*****************/
            // let doc = new docxtemplater()
            //     .attachModule(imageModule)  //图片导出功能
            //     .loadZip(zip)
            //     .setOptions({
            //         paragraphLoop: true,
            //         linebreaks: true
            //     })
            //     .compile();
            /*****************旧方式*****************/

            const doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
                modules: [imageModule]
            });

            // 生成一个代表 docxtemplater 对象的 zip 文件（不是一个真实的文件，而是在内存中的表示）
            doc.setData(wordData);

            // 渲染文件
            try {
                doc.render();
            } catch (error) {
                function replaceErrors(key, value) {
                    if (value instanceof Error) {
                        return Object.getOwnPropertyNames(value).reduce(function (error, key) {
                            error[key] = value[key];
                            return error;
                        },
                            {});
                    }
                    return value;
                }
                console.log(JSON.stringify({ error: error }, replaceErrors));

                if (error.properties && error.properties.errors instanceof Array) {
                    const errorMessages = error.properties.errors
                        .map(function (error) {
                            return error.properties.explanation;
                        })
                        .join('\n');
                    console.log('errorMessages', errorMessages);
                    //   errorMessages is a humanly readable message looking like this :
                    //   'The tag beginning with 'foobar' is unopened'
                }
                throw error;
            }

            var out = doc.getZip().generate({
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });
            new Promise(function (resolve, reject) {
                // 将目标文件对象保存为目标类型的文件，并命名。
                try {
                    saveAs(out, record.name + '.' + props.month + '-月报.docx');
                    resolve();
                } catch {
                    reject();
                }
            }).then(() => {
                // 完成下载
                modal.update((prevConfig) => ({
                    ...prevConfig,
                    content: <Progress percent={100} />,
                }));
                //  下载完成后，退出报表界面
                messageApi.success('下载完成！', CNF.messageDuration);
                setTimeout(() => {
                    Modal.destroyAll(); // 退出下载进度界面
                    cancel();
                }, CNF.messageDuration * 1000);
            }, () => {
                Modal.destroyAll(); // 退出下载进度界面
                setLoading(false);
                message.error('下载失败！', CNF.messageDuration);
            })
        });
    }

    /**
     * 下载
     * 为导出word做数据准备
     */
    async function download() {
        // 下载期间禁止在此下载
        if (loading) return;
        setLoading(true);

        // 弹出下载进度界面
        const modal = Modal.info({
            title: '工单月报下载中···',
            icon: null,
            content: <Progress percent={0} />,
            footer: null,
            keyboard: false,
        });

        // 图片总数量
        let imageCount = woImageList.length + 4;

        // 报表图标转换
        let g2ImageBase64Urls = await g2ToWordData(modal, imageCount);

        // 下载图片并转换为base64
        let woImageListBase64Urls = [];
        if (woImageList.length > 0) woImageListBase64Urls = await woImageToWordData(modal, woImageList, imageCount, 4);
        exportAsWord(modal, g2ImageBase64Urls, woImageListBase64Urls);
    }

    // 工单明细表头
    const columnsWO = [
        { title: '工单编号', dataIndex: 'number', key: 'number', width: 80, },
        { title: '工单描述', dataIndex: 'content', key: 'content', width: 100, ellipsis: true },
        { title: '工单点位', dataIndex: 'point', key: 'point', width: 50, ellipsis: true },
        { title: '工单等级', dataIndex: 'level_name', key: 'level_name', width: 80, },
        { title: '工单类型', dataIndex: 'type_name', key: 'type_name', width: 50, },
        { title: '原因分析', dataIndex: 'cause', key: 'cause', width: 90, ellipsis: true },
        { title: '处理方式', dataIndex: 'do_mode', key: 'do_mode', width: 80, ellipsis: true },
        { title: '处理开始时间', dataIndex: 'start_time', key: 'start_time', width: 80, },
        { title: '处理结束时间', dataIndex: 'end_time', key: 'end_time', width: 80, },
        { title: '处理人员', dataIndex: 'do_user', key: 'do_user', width: 50, }
    ];
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            <Modal
                style={{ top: 0, padding: 0 }}
                closable={false}
                maskClosable={true}
                open={open}
                keyboard={true}
                width={820}
                onCancel={cancel}
                okText='下载'
                cancelText='取消'
                footer={[
                    <Button key='back'
                        disabled={loading}
                        onClick={cancel}>取消</Button>,
                    <Button key='link'
                        type='primary'
                        onClick={download}
                        loading={loading}
                        iconPosition='end'
                        style={{ marginRight: '24px' }}>{loading ? '下载中' : '下载'}</Button>,
                ]}
            >
                {contextHolder}
                <div id='wo-report-id'>
                    <div style={{ padding: '20px 16px' }}>
                        <Row style={{ marginBottom: 15 }}>
                            <Col span={2}><img src={props.preGroup === 'zhc' ? ZHCLOGO : XZTLOGO} height={props.preGroup === 'zhc' ? '80px' : '45px'} alt={props.preGroup === 'zhc' ? '智慧城' : '新致腾'} /></Col>
                            {
                                props.preGroup === 'xzt' ? <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt='新致腾' /></Col> : ''
                            }
                        </Row>
                        <Row style={{ marginTop: 100 }} justify='center'><Col><h1>{props.record.name}</h1></Col></Row>
                        <Row justify='center'> <Col><h1>月度维护报表</h1></Col></Row>
                        <Row justify='center'><Col><p>（{props.month}）</p></Col></Row>
                        <Row style={{ marginTop: 250 }} justify='center'><Col><h3>{props.preGroup === 'zhc' ? ZHCCOMPANY : XZTCOMPANY}</h3></Col></Row>
                        <Row style={{ marginTop: 250 }}><Col><h1>一、本月维护概况</h1></Col></Row>
                        <Row><Col span={23} offset={1}>{props.record.name}维护内容综述：</Col></Row>
                        <Row><Col span={23} offset={1}>
                            <div id='maintenance-content-id'>
                                {
                                    props.record.maintenance_content.split('\n').map((item, index) => {
                                        return <p key={index}>{item}</p>;
                                    })
                                }
                            </div>
                        </Col></Row>
                        <Row style={thStyle}><Col><h2>（一）本月系统运行情况</h2></Col></Row>
                        <Row>
                            <Col span={23} offset={1}>
                                <p>本月共提交 <strong>{woCount}</strong> 个工单.</p>
                                <p><strong>按等级分：</strong></p>
                                {
                                    CNF.woLevels && CNF.woLevels.map((item) => {
                                        return <p key={item.key}>{item.key} <strong>{woLevelData?.find((obj) => obj.type === item.key)?.count}</strong> 个；</p>
                                    })
                                }
                                <p><strong>按分类分：</strong></p>
                                {
                                    CNF.woTypes && CNF.woTypes.map((item) => {
                                        return <p key={item.key}>{item.key} <strong>{woTypeData?.find((obj) => obj.type === item.key)?.count || 0}</strong> 个；</p>
                                    })
                                }
                                <p>根据{props.record.name}的维护协议，本月发生的故障在可控范围之内，均达到合同所规定的要求。</p>
                            </Col>
                        </Row>
                        <Row style={thStyle}><Col><h2>（二）本月工作完成情况</h2></Col></Row>
                        <Row><Col><h3>1.上月遗留问题</h3></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>
                        <Row style={thStyle}><Col><h3>2.本月故障处理</h3></Col></Row>
                        <Row><Col span={23} offset={1}><strong>{woCount}</strong> 个工单已全部处理，完成率 <strong>100%</strong>。</Col></Row>
                        <Row style={thStyle}><Col><h3>3.本月日常巡检</h3></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>
                        <Row style={thStyle}><Col><h3>4.清洁保养工作</h3></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>

                        <Row style={{ marginTop: 50 }}><Col><h1>二、本月工单明细</h1></Col></Row>
                        <Row><Col span={23} offset={1}>从不同维度对工单进行统计。</Col></Row>
                        <Row style={thStyle}><Col><h2>（一）日工单处理走势</h2></Col></Row>
                        <WOWTCD data={woDayData} />
                        <Row style={thStyle}><Col><h2>（二）按工单等级统计</h2></Col></Row>
                        <WOWDCL data={woLevelData} />
                        <Row style={thStyle}><Col><h2>（三）按工单分类统计</h2></Col></Row>
                        <WOWDCT data={woTypeData} />
                        <Row style={thStyle}><Col><h2>（四）按工单产品统计</h2></Col></Row>
                        <WOWDCP data={woProductData} />
                        <Row style={thStyle}><Col><h2>（五）工单明细汇总表</h2></Col></Row>
                        <Table
                            columns={columnsWO}
                            style={{ width: '100%', }}
                            bordered
                            pagination={false}
                            size='middle'
                            dataSource={woData}
                        />
                        <Row style={{ marginTop: 50 }}><Col><h1>三、本月工单分析</h1></Col></Row>
                        <Row style={thStyle}><Col><h2>（一）工单响应分析</h2></Col></Row>
                        <Row><Col span={23} offset={1}>平均故障响应时间 ≤ <strong>2</strong> 小时。</Col></Row>
                        <Row style={thStyle}><Col><h2>（二）工单处理分析</h2></Col></Row>
                        <Row>
                            <Col span={23} offset={1}>
                                <p>单日最高处理工单数：<strong>{dayMaxCount}</strong> 个 (<strong>{dayMaxDate}</strong>)；</p>
                                <p>每日平均处理工单数：<strong>{dayAverageCount}</strong> 个；</p>
                                <p>每个工单处理平均耗时：{avgWOSecondsText}；</p>
                                <p>处理耗时最长的工单：总共耗时：{longestWOSecondsText}；工单编号：<strong>{longestWONumber}</strong>；开始时间：{longestWOStartTime}；结束时间：{longestWOEndTime}；情况说明：{longestWODescription}</p>
                                <p>工单次数最高的产品：产品编码：<strong>{productMaxNumber}</strong>；工单次数：<strong>{productMaxCount}</strong></p>
                                <p>工单主要原因：</p>
                                <p>平均到达现场处理时间 ≤ <strong>24</strong> 小时。</p>
                                <p>我方处理能力范围内的故障平均处理时间 ≤ <strong>48</strong> 小时。</p>
                            </Col>
                        </Row>
                        <Row style={thStyle}><Col><h2>（三）客户反馈分析</h2></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>

                        <Row style={{ marginTop: 50 }}><Col><h1>四、问题与建议</h1></Col></Row>
                        <Row style={thStyle}><Col><h2>（一）存在的问题</h2></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>
                        <Row style={thStyle}><Col><h2>（二）相关的建议</h2></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>

                        <Row style={{ marginTop: 50 }}><Col><h1>五、本月遗留问题汇总</h1></Col></Row>
                        <Row style={thStyle}><Col><h2>（一）工单遗留明细</h2></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>
                        <Row style={thStyle}><Col><h2>（二）工单遗留原因</h2></Col></Row>
                        <Row><Col span={23} offset={1}>暂无。</Col></Row>

                        <Row style={{ marginTop: 400 }}><Col offset={1} span={11}>填报人：</Col><Col offset={1} span={11}>维护主管代表签字：</Col></Row>
                        <Row style={{ marginTop: 200 }}><Col offset={1} span={11}>审核人：</Col><Col offset={1} span={11}>业主单位代表签字（盖章）：</Col></Row>
                        <Row style={{ marginTop: 200, marginBottom: 400 }}><Col offset={1} span={11}>领导：</Col><Col offset={1} span={11}>业主单位领导签字（盖章）：</Col></Row>
                        {
                            props.btnLists.indexOf('btn_plms_wo_image') >= 0 && woImageList.length > 0 ? <>
                                <div>
                                    <p>附图：</p>
                                    <ConfigProvider locale={locale}>
                                        {
                                            woImageList.map((item, index) => {
                                                return <AntdImage
                                                    key={index}
                                                    alt={item.name}
                                                    width='50%'
                                                    src={item.url}
                                                    style={{ verticalAlign: 'top', maxWidth: '100%', height: 'auto' }}
                                                    fallback={defaultImage}
                                                />
                                            })
                                        }
                                    </ConfigProvider>
                                </div>
                            </> : ''
                        }
                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    );
}

export default MREntity;